import React, { ReactNode } from 'react';
import { FaExclamationCircle } from 'react-icons/fa';
import './AlertBanner.css';

interface Props {
  children?: ReactNode;
  alertText: string;
  alertTextHeader?: string | null;
  testid?: string;
}

const AlertBanner = (props: Props) => {
  return (
    <>
      <div
        id={props.testid}
        data-testid={`${props.testid}`}
        className={`d-flex mb-3 helpdeskMessage px-0 alert-error bg-white`}
      >
        <div
          className={`d-flex align-items-center bg-cherry infoIconContainer`}
        >
          <FaExclamationCircle className={`infoIcon my-3 mx-3`} />
        </div>
        <div className='d-flex flex-column justify-content-cente px-3 my-2'>
          {props.alertTextHeader && (
            <div
              className='text-graphite font-header-bold font-weight-bold'
              dangerouslySetInnerHTML={{ __html: props.alertTextHeader }}
            />
          )}
          <div
            className='text-graphite font-header-regular'
            dangerouslySetInnerHTML={{ __html: props.alertText }}
          />
        </div>
      </div>
    </>
  );
};

export default AlertBanner;
